<template>
  <div>
    <Header />
    <v-card elevation="2" class="mx-auto header-row">
      <v-row class="ma-0 pa-0">
        <v-col :cols="12" :lg="6" :md="6" :sm="12" class="d-flex align-center">
          <p class="py-0 pl-3 my-0 header-text text-white text-uppercase">
            {{ $store.state.lang.tanulmanyi_tajekoztato_rendszer }}
          </p>
        </v-col>
        <v-col :cols="12" :lg="6" :md="6" :sm="12">
          <LangSelector />
          <div class="float-right">
            <v-btn @click="sugoDialog(3)" class="ma-1 float-right" color="white" dark outlined elevation="0">{{
              $store.state.lang.sugo }}</v-btn>
            <v-btn color="white" dark outlined class="ma-1 float-right"
              href="https://ttr.sze.hu/Shibboleth.sso/Login?target=https://ttr.sze.hu/api/loginShib"
              v-if="show_login == true" elevation="0">
              <v-icon left>mdi-login</v-icon>
              {{ $store.state.lang.bejelentkezes }}
            </v-btn>
            <v-btn elevation="0" class="ma-1 float-right" @click="Logout" target="blank" color="white" dark outlined
              v-if="show_login == false">
              <v-icon left>mdi-login</v-icon>
              {{ $store.state.lang.kijelentkezes }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- class="mx-auto mb-5 mt-2 pa-5" -->
    <v-card elevation="0" class="mx-auto bg-transparent mt-4 mb-12 pa-0 main-card">
      <v-row class="ma-0 pa-0">
        <v-col :cols="12" :lg="8" :md="8" :sm="12" class="ma-0 py-0 px-0">
          <v-card elevation="1" class="ma-0 pa-2 mb-4 custom-right-margin" v-if="show_login == false">
            <v-row class="my-0 mx-2 py-1 px-0">
              <p class="ma-0 pa-0 text-uppercase font-weight-medium text-h6">
                {{ $store.state.lang.egyeni_elorehaladas }}
              </p>
            </v-row>
            <v-row class="mx-2 my-0 pa-0 leiras pt-1 pb-5">{{
              $store.state.lang.box_1_szoveg
            }}</v-row>
            <v-row class="ma-0 px-0 pb-2 pt-0">
              <v-col :cols="12" :lg="12" :md="12" :sm="12" class="ma-0 pa-0">
                <!-- v-if="show_user_plans" -->
                <v-autocomplete :items="user_sample_plans" item-value="Mintatanterv_kod" item-text="Mintatanterv_nev"
                  v-model="user_selected_sample_plan" :label="$store.state.lang.mintaterv" class="mx-2 mt-0 pt-1 pb-1"
                  :hide-details="true" :flat="true" item-color="uni_blue2" color="uni_blue2" return-object>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pb-3">
              <v-col :cols="12" :lg="2" :md="2" :sm="2" class="ma-0 pa-0 d-flex justify-start align-end">
                <!-- v-if="show_login == false" -->
                <!-- :disabled="user_selected_sample_plan == ''" -->
                <v-btn elevation="0" target="_blank" @click="goToMatrix" class="mx-3 float-right text-white"
                  color="uni_blue2">{{ $store.state.lang.tovabb }}</v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="1" class="ma-0 pa-2 mb-4 custom-right-margin">
            <v-row class="mx-2 py-1 my-0 px-0 font-weight-medium text-h6">{{
              $store.state.lang.online_tajekoztato
            }}</v-row>
            <v-row class="mx-2 pt-1 pb-5 my-0 px-0 leiras d-flex">
              <p class="ma-0 pa-0">
                {{ $store.state.lang.box_2_szoveg }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="sugoicon"
                      @click="sugoDialog(1)">mdi-help-circle-outline</v-icon></template>
                  <p class="ma-0 pa-0">{{ $store.state.lang.tovabbi_info }}</p>
                </v-tooltip>
              </p>
            </v-row>
            <!-- <a
              text
              color="uni_blue ma-2"
              class="link"
              target="_blank"
              href="https://neptun.sze.hu/on-line-kiadott-tajekoztatok"
              >{{ lang.elotte }}</a
            > -->
            <v-row class="mx-2 leiras d-flex">
              <v-alert text color="info" dense width="auto">
                <a color="uni_blue ma-2" class="mx-1 pa-0 link_2 text-caption" target="_blank"
                  href="https://neptun.sze.hu/on-line-kiadott-tajekoztatok">
                  {{ $store.state.lang.link }} <v-icon>mdi-arrow-right</v-icon>
                </a>
              </v-alert></v-row>
            <v-divider class="mx-4"></v-divider>
            <v-flex class="scroll">
              <v-treeview color="uni_blue" :items="items" open-on-click class="scroll" hoverable>
                <template v-slot:label="{ item }">
                  <v-btn v-if="item.href" plain :to="`/tanulmanyi_tajekoztato/${langName == 'hu'
                    ? item.language == 'hu'
                      ? 'hu'
                      : 'en'
                    : 'en'
                    }/${item.href}`" target="_blank" color="uni_blue" class="text-white"><span
                      v-if="langName == 'hu'">{{ item.name }}</span><span v-else>{{ item.name_en }}</span></v-btn>
                  <span v-else>{{
                    langName == "hu" ? item.name : item.name_en
                  }}</span>
                  <v-tooltip v-if="item.href" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="uni_blue" plain dark small class="mx-1" v-bind="attrs" v-on="on"
                        @click="downloadHomePdf(item)">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
                    <span class="align-center">{{ $store.state.lang.letoltes }}<br />{{ item.created }}</span>
                  </v-tooltip>
                </template>
              </v-treeview>
            </v-flex>
          </v-card>
        </v-col>
        <v-col :cols="12" :lg="4" :md="4" :sm="12" class="ma-0 py-0 px-0">
          <v-card elevation="1" class="sticky pa-2 ma-0">
            <v-card class="" elevation="0">
              <v-row class="ma-0 px-2 py-1 font-weight-medium text-h6">{{
                $store.state.lang.hallgatoi_tantervek
              }}</v-row>
              <v-row class="ma-0 px-2 py-0 pt-1 pb-5 leiras d-flex">
                <p class="ma-0 pa-0">
                  {{ $store.state.lang.box_3_szoveg }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" class="sugoicon"
                        @click="sugoDialog(2)">mdi-help-circle-outline</v-icon></template>
                    <p class="ma-0 pa-0">{{ $store.state.lang.tovabbi_info }}</p>
                  </v-tooltip>
                </p>
              </v-row>
              <v-row class="py-0 px-2 ma-0">
                <v-container class="pa-0">
                  <v-radio-group v-model="radioGroup" @change="radioGroupGet">
                    <div class="d-flex mb-1">
                      <v-radio :label="$store.state.lang.tantargylista" key="1" class="ma-0 pa-0 mr-1" value="1"
                        color="uni_blue2"></v-radio>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="sugoicon"
                            @click="sugoDialog(4)">mdi-help-circle-outline</v-icon></template>
                        <p class="ma-0 pa-0">{{ $store.state.lang.tovabbi_info }}</p>
                      </v-tooltip>
                    </div>
                    <div class="d-flex mb-1">
                      <v-radio :label="$store.state.lang.tantargyak_javasolt_felveteli_sorrendje" key="2" value="2"
                        class="ma-0 pa-0 mr-1" color="uni_blue2"></v-radio>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="sugoicon"
                            @click="sugoDialog(5)">mdi-help-circle-outline</v-icon></template>
                        <p class="ma-0 pa-0">{{ $store.state.lang.tovabbi_info }}</p>
                      </v-tooltip>
                    </div>
                    <v-radio :label="$store.state.lang.tantargytematika_keresés" key="3" value="3"
                      color="uni_blue2"></v-radio>
                  </v-radio-group>
                </v-container>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-select :label="$store.state.lang.nyelv" :items="languages" color="uni_blue2" item-text="name"
                  item-value="id" item-color="uni_blue" return-object v-model="searchLang" v-if="radioGroup != 3"
                  @change="searchLanguageChange">
                </v-select>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-tooltip bottom v-if="
                  ((radioGroup != 3 &&
                    searchLang &&
                    searchLang.name == 'Magyar') ||
                    (radioGroup != 3 && !searchLang)) &&
                  searchFaculty
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <v-autocomplete v-bind="attrs" v-on="on" :label="$store.state.lang.szak" :items="faculties"
                      color="uni_blue2" item-value="ID" :item-text="langName == 'hu' ? 'display_name_hu' : 'display_name_en'
                        " return-object item-color="uni_blue" v-model="searchFaculty" :disabled="!searchLang"
                      @input="searchFacultyChange">
                      <template v-slot:item="{ item }">
                        <p class="pa-0 ma-0 border-bottom">
                          {{
                            langName == "hu"
                              ? item.display_name_hu
                              : item.display_name_hu
                          }}
                        </p>
                      </template>
                    </v-autocomplete>
                  </template>
                  <span v-if="searchFaculty">{{
                    searchFaculty.display_name_hu
                  }}</span>
                </v-tooltip>
                <v-autocomplete :label="$store.state.lang.szak" :items="faculties" color="uni_blue2" item-value="ID"
                  :item-text="langName == 'hu' ? 'display_name_hu' : 'display_name_en'
                    " return-object item-color="uni_blue" v-model="searchFaculty" :disabled="!searchLang"
                  @input="searchFacultyChange" v-if="
                    ((radioGroup != 3 &&
                      searchLang &&
                      searchLang.name == 'Magyar') ||
                      (radioGroup != 3 && !searchLang)) &&
                    !searchFaculty
                  ">
                  <template v-slot:item="{ item }">
                    <p class="pa-0 ma-0 border-bottom">
                      {{
                        langName == "hu"
                          ? item.display_name_hu
                          : item.display_name_hu
                      }}
                    </p>
                  </template>
                </v-autocomplete>
                <v-tooltip bottom v-if="
                  ((radioGroup != 3 &&
                    searchLang &&
                    searchLang.name == 'English') ||
                    (radioGroup != 3 && !searchLang)) &&
                  searchFaculty
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <v-autocomplete v-bind="attrs" v-on="on" :label="$store.state.lang.szak" :items="faculties"
                      color="uni_blue2" item-value="ID" item-text="display_name_en" return-object item-color="uni_blue"
                      v-model="searchFaculty" :disabled="!searchLang" @input="searchFacultyChange">
                      <template v-slot:item="{ item }">
                        <p class="pa-0 ma-0 border-bottom">
                          {{
                            langName == "en" || searchLang.name == "English"
                              ? item.display_name_en
                              : item.display_name_hu
                          }}
                        </p>
                      </template>
                    </v-autocomplete>
                  </template>
                  <span v-if="searchFaculty">{{
                    searchFaculty.display_name_en
                  }}</span>
                </v-tooltip>
                <v-autocomplete :label="$store.state.lang.szak" :items="faculties" color="uni_blue2" item-value="ID"
                  item-text="display_name_en" return-object item-color="uni_blue" v-model="searchFaculty"
                  :disabled="!searchLang" @input="searchFacultyChange" v-if="
                    radioGroup != 3 &&
                    searchLang &&
                    searchLang.name == 'English' /*||
                      (radioGroup != 3 && !searchLang)*/ &&
                    !searchFaculty
                  ">
                  <template v-slot:item="{ item }">
                    <p class="pa-0 ma-0 border-bottom">
                      {{
                        langName == "en" || searchLang.name == "English"
                          ? item.display_name_en
                          : item.display_name_hu
                      }}
                    </p>
                  </template>
                </v-autocomplete>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-autocomplete :label="$store.state.lang.szakirany" :items="specializations" color="uni_blue2"
                  return-object item-text="title" item-value="F6" item-color="uni_blue" v-model="searchSpecialization"
                  v-if="radioGroup != 3" @change="searchSpecializationChange" :disabled="!searchFaculty || !searchLang">
                </v-autocomplete>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-autocomplete :label="$store.state.lang.mintaterv" :items="samplePlans" color="uni_blue2"
                  return-object item-text="F10" item-value="F9" item-color="uni_blue" v-model="searchSamplePlan"
                  v-if="radioGroup != 3" :disabled="!searchLang || !searchFaculty || !searchSpecialization
                    ">
                  <template v-slot:item="{ item }">
                    <p class="fontSize">{{ item.F10 }}</p>
                  </template>
                </v-autocomplete>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-text-field :label="$store.state.lang.targy" item-color="uni_blue" color="uni_blue2"
                  v-model="subSearch.subject" v-if="radioGroup == 3" />
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-text-field :label="$store.state.lang.targykod" item-color="uni_blue" color="uni_blue2"
                  v-model="subSearch.subjectCode" v-if="radioGroup == 3" />
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-autocomplete :label="$store.state.lang.tanszek" item-color="uni_blue" color="uni_blue2"
                  :items="sub_departments" return-object item-value="F0" item-text="F1" v-model="subSearch.department"
                  v-if="radioGroup == 3"></v-autocomplete>
              </v-row>
              <v-row class="py-0 px-0 ma-0">
                <v-autocomplete :label="$store.state.lang.tanszekkod" item-color="uni_blue" color="uni_blue2"
                  :items="sub_departments" return-object item-value="F0" item-text="F0" v-model="subSearch.department"
                  v-if="radioGroup == 3"></v-autocomplete>
              </v-row>
              <v-row class="py-2 px-2 ma-0">
                <v-btn color="uni_blue" class="text-white" v-if="radioGroup == 1" target="_blank"
                  @click="goToTantargyLista" :disabled="!searchLang ||
                    !searchFaculty ||
                    !searchSpecialization ||
                    !searchSamplePlan
                    ">{{ $store.state.lang.kereses }}</v-btn>

                <v-btn color="uni_blue" class="text-white" v-if="radioGroup == 2" target="_blank" :to="`/matrix/${langName == 'en' ||
                  (searchLang && searchLang.name == 'English')
                  ? 'en'
                  : 'hu'
                  }?mt=${searchSamplePlan ? searchSamplePlan.F9 : ''}`" :disabled="!searchLang ||
                    !searchFaculty ||
                    !searchSpecialization ||
                    !searchSamplePlan
                    ">{{ $store.state.lang.kereses }}</v-btn>
                <v-btn color="uni_blue" class="text-white" v-if="radioGroup == 3" target="_blank"
                  @click="getSearchedSubjects">{{ $store.state.lang.kereses }}</v-btn>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="sdialog" width="70%">
        <v-card>
          <v-card-text class="ma-0 pa-0">
            <Sugo :type="sugoType" :title="$store.state.lang.sugo" :langName="langName" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog v-model="subjectDialog" width="1000px">
        <v-card class="pa-0 ma-0">
          <v-card-title class="pa-3 d-flex justify-end sticky">
            <v-icon @click="subjectDialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="ma-0 pa-0">
            <TantargyTematika :subject="searched_Subjects" :search="subSearch" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import LangSelector from "@/components/LangSelector.vue";
import TantargyTematika from "@/components/TantargyTematika.vue";
import Header from "@/components/Header.vue";
import hu from "@/plugins/hu.json";
import Sugo from "@/components/Sugo.vue";
export default {
  name: "Home",
  components: {
    LangSelector,
    Sugo,
    Header,
    TantargyTematika,
  },
  data: () => ({
    sdialog: false,
    subjectDialog: false,
    treeSearch: {
      year: "",
      samplePlan: "",
    },

    searchLang: null,
    searchDepartment: null,
    searchFaculty: null,
    searchSpecialization: null,
    searchSamplePlan: null,

    subSearch: {
      subject: "",
      subjectCode: "",
      department: "",
      departmentCode: "",
    },
    subject: {},
    subjects: [],
    active: [],
    open: [],
    selected: true,
    selectedTantargy: null,
    tantargylista: true,
    tantargymatrix: false,
    radioGroup: "1",
    languages: [
      { id: 0, name: "Magyar" },
      { id: 1, name: "English" },
    ],
    department: [],
    specializations: [],
    samplePlans: [],
    items: [],
    semesterautocomplete: [],
    samplePlanautocomplete: [],
    faculties: [],
    sub_departments: [],
    searched_Subjects: [],
    user_sample_plans: [],
    show_user_plans: false,
    show_login: false,
    user_selected_sample_plan: "",
    sugoType: 3,
  }),
  beforeDestroy() {
    if (this.alertTimer) {
      clearTimeout(this.alertTimer);
    }
  },
  async mounted() {
    try {
      const responseCheckLogin = await this.$http.get("/checkLogin");
      if (responseCheckLogin.logged == true) {
        this.show_login = false;
        this.user_sample_plans = responseCheckLogin.user_sample_plans;
      } else {
        this.show_login = true;
      }

      const alert = {
        show: true,
        type: "error",
        message: responseCheckLogin.valasz,
      };

      if (responseCheckLogin.valasz != "") {
        if (responseCheckLogin.valasz == "no error") {
          alert.message = this.$store.state.lang.sikeres_bejelentkezes;
          alert.type = "success";
        } else {
          alert.message = this.$store.state.lang.nincs_aktiv_jogviszony;
          alert.type = "warning";
        }
        this.$store.dispatch("showAlert", alert);
        if (responseCheckLogin.user_sample_plans) {
          this.show_user_plans = true;
        }
      }

      this.$store.commit("setOverlay", true);
      const response = await this.$http.get("/gettree");
      this.items = response.tree;
      if ('kod' in this.$route.params) {
        this.subSearch.subjectCode = this.$route.params.kod;
        if (this.$route.params.kod == "N_ED20_A") {
          this.subSearch.subjectCode == "N_ED20/A";
        }
        this.getSearchedSubjects();
      } else if (this.$route.query.tsz) {
        this.subSearch.department = { F0: this.$route.query.tsz };
        try {
          const response_ = await this.$http.get("/subdepartments", { params: { tsz: this.$route.query.tsz } });
          this.subSearch.department = response_.departments;
        } catch (e) {
          console.error(e);
        }
        this.getSearchedSubjects();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.$store.commit("setOverlay", false);
    }
  },

  computed: {
    langName() {
      return this.$store.state.lang == hu ? "hu" : "en";
    },
  },
  methods: {
    async radioGroupGet() {
      try {
        if (this.radioGroup == "3") {
          this.$store.commit("setOverlay", true);
          if (this.sub_departments.length == 0) {
            const response_ = await this.$http.get("/subdepartments");
            this.sub_departments = response_.departments;
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.commit("setOverlay", false);
      }
    },
    downloadHomePdf(item) {
      try {
        const link = document.createElement("a");
        link.setAttribute("target", "_blank");
        if (this.langName == "hu") {
          link.href = "https://ttr.sze.hu/api/tmp/" + item.link.pdf_hu + ".pdf";
          link.setAttribute("download", item.link.pdf_hu + ".pdf");
        } else {
          link.href = "https://ttr.sze.hu/api/tmp/" + item.link.pdf_en + ".pdf";
          link.setAttribute("download", item.link.pdf_en + ".pdf");
        }

        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.error(e);
      }
    },
    goToTantargyLista() {
      if (!this.searchSamplePlan) {
        const alert = {
          show: true,
          type: "error",
          message: this.$store.state.lang.nincs_targy,
        };
        this.$store.dispatch("showAlert", alert);
        return;
      }

      const lang =
        this.langName == "en" || this.searchLang.name == "English"
          ? "en"
          : "hu";
      let route = this.$router.resolve({
        path: "tantargy_lista/" + lang + "/" + this.searchSamplePlan.F9,
      });
      window.open(route.href);
    },
    async getSearchedSubjects() {
      this.searched_Subjects = [];
      this.subSearch.subject = this.subSearch.subject.trim();
      this.subSearch.subjectCode = this.subSearch.subjectCode.trim();

      if (Object.values(this.subSearch).every((x) => x === null || x === "")) {
        const alert = {
          show: true,
          type: "error",
          message: this.$store.state.lang.nincs_targy,
        };
        this.$store.dispatch("showAlert", alert);
        return;
      }
      try {
        const response = await this.$http.get(
          "/getSearchedSubjects",
          { params: this.subSearch }
        );
        if (response.subjects.length == 0) {
          const alert = {
            show: true,
            type: "error",
            message: this.$store.state.lang.nincs_targy,
          };
          this.$store.dispatch("showAlert", alert);
          return;
        }
        this.searched_Subjects = response.subjects;
        this.subjectDialog = true;
      } catch (e) {
        console.error(e);
      }
    },
    sugoDialog(id) {
      this.sugoType = id;
      this.sdialog = true;
    },
    async goToMatrix() {
      let route = this.$router.resolve({
        path:
          "/tanulo_matrix/" +
          this.langName +
          "/" +
          this.user_selected_sample_plan.Modulkod +
          "/" +
          this.user_selected_sample_plan.Mintatanterv_kod,
      });

      window.open(route.href);
    },
    Logout() {
      this.show_login = true;
      this.show_user_plans = false;
      window.open("https://ttr.sze.hu/Shibboleth.sso/Logout");
    },

    async searchLanguageChange() {
      try {
        if (!this.searchLang) {
          return;
        }
        this.faculties = [];

        this.searchFaculty = null;
        this.searchSpecialization = null;
        this.searchSamplePlan = null;

        const response = await this.$http.get(
          "getHomeFaculties/",
          { params: { lang: this.searchLang } }
        );
        this.faculties = response.faculties;
      } catch (e) {
        console.error(e);
      }
    },

    async searchFacultyChange() {
      try {
        if (!this.searchFaculty) {
          return;
        }

        this.searchSpecialization = null;
        this.searchSamplePlan = null;

        const response = await this.$http.get("getHomeSpecializations/", {
          params: {
            lang: this.searchLang,
            facultyCode: this.searchFaculty.F2,
            dayType: this.searchFaculty.F4,
            level: this.searchFaculty.F5
          }
        });

        this.specializations = response.specializations;
        this.searchSpecialization =
          this.specializations[this.specializations.length - 1];

        this.searchSpecializationChange();
      } catch (e) {
        console.error(e);
      }
    },

    async searchSpecializationChange() {
      try {
        if (!this.searchSpecialization) {
          return;
        }

        this.searchSamplePlan = null;
        const response = await this.$http.get("getHomeSamplePlans/", {
          params: {
            lang: this.searchLang,
            facultyCode: this.searchFaculty.F2,
            dayType: this.searchFaculty.F4,
            level: this.searchFaculty.F5,
            specCode: this.searchSpecialization.F6,
          }
        });
        this.samplePlans = response.sample_plans;
        this.searchSamplePlan = this.samplePlans[this.samplePlans.length - 1];
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style scoped>
.alert {
  position: fixed;
  left: 50%;
  bottom: 2rem;
  transform: translate(-50%, 50%);
  margin: 0 auto;
  z-index: 10000;
}

.scroll {
  overflow-x: auto;
  width: max-content;
  min-width: 100%;
  z-index: 5;
}

.fontSize {
  padding: 0px;
  margin: 0px;
  font-size: 14px;
}

.v-icon::hover {
  color: transparent;
}

.v-icon::after {
  color: transparent;
}

.header-text {
  font-size: 1.5rem;
  font-weight: 600;
}

.alert {
  color: white;
  position: fixed;
  left: 50%;
  bottom: 2rem;
  transform: translate(-50%, 50%);
  margin: 0 auto;
  /* Without this the box extends the width of the page*/
}

.link {
  margin-left: 0.6rem;
  display: inline-block;
  position: relative;
  text-decoration: none;
  overflow: hidden;
}

.link::after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 0.1em;
  transform: scaleX(0);
  background-color: #0c3c60;
  transform-origin: bottom right;
}

.link:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
  transition: transform 0.25s ease-in;
}

.leiras {
  font-size: 0.8rem;
}

.sugoicon {
  cursor: pointer;
}

.link_2 {
  text-decoration: none;
}

.custom-right-margin {
  margin-right: 16px !important;
}

@media (max-width: 960px) {
  .custom-right-margin {
    margin-right: 0 !important;
  }
}
</style>
